var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiBexLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 113.918,
    height: 113.832,
    viewBox: "0 0 113.918 113.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.796,
    y1: 0.19,
    x2: 0.071,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6af47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3869"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2463",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2463",
    transform: "translate(-388.2 -621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2417",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2417",
    transform: "translate(388.2 707.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9755",
    "data-name": "\\u30D1\\u30B9 9755",
    d: "M13,76.8l5.8,12.452H7.1ZM0,99.454H2.227l4.132-8.63H19.542l4.13,8.63H25.9L13.042,72.384Z",
    transform: "translate(0 -72.384)",
    fill: "#fc9819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9756",
    "data-name": "\\u30D1\\u30B9 9756",
    d: "M24.3,74.637a1.677,1.677,0,0,1,1.829-1.6,1.611,1.611,0,1,1,0,3.192,1.677,1.677,0,0,1-1.829-1.6",
    transform: "translate(7.173 -72.247)",
    fill: "#fc9819"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_27261",
    "data-name": "\\u9577\\u65B9\\u5F62 27261",
    width: 2.031,
    height: 17.598,
    transform: "translate(32.285 9.472)",
    fill: "#fc9819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9757",
    "data-name": "\\u30D1\\u30B9 9757",
    d: "M35.928,73.042v10.91a10.979,10.979,0,0,1,8.578-3.642c6.595,0,10.614,4.188,10.614,9.559,0,5.461-4.073,9.921-10.72,9.921-5.415,0-7.828-2.912-8.471-3.823v3.322H33.784V73.042ZM52.869,89.869c0-5.1-3.967-7.829-8.47-7.829-4.289,0-8.579,2.6-8.579,7.737,0,4.642,3,8.284,8.524,8.284s8.524-3.642,8.524-8.192",
    transform: "translate(9.163 -72.246)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9758",
    "data-name": "\\u30D1\\u30B9 9758",
    d: "M57.75,88.973c0,4.733,4.075,7.826,8.684,7.826a8.5,8.5,0,0,0,7.613-4.232l1.823.911a10.785,10.785,0,0,1-9.6,5.051c-6.809,0-10.777-4.278-10.777-9.693,0-6.463,5.254-9.786,10.616-9.786,5.9,0,10.345,4.006,10.345,9.923Zm16.458-1.73c-.536-3.686-3.753-6.463-8.095-6.463-4.451,0-7.613,2.866-8.2,6.463Z",
    transform: "translate(13.719 -70.986)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9759",
    "data-name": "\\u30D1\\u30B9 9759",
    d: "M83.132,88.218l-8.095-8.829h2.627l6.917,7.646,6.808-7.646h2.628l-7.934,8.829,8.792,9.739H92.246L84.58,89.4l-7.667,8.556H74.287Z",
    transform: "translate(19.045 -70.915)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2464",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2464",
    transform: "translate(405.367 621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9760",
    "data-name": "\\u30D1\\u30B9 9760",
    d: "M76.756,11.96c-4.484-4.966-6.413-5.064-11.38-.581C70.342,6.9,70.44,4.966,65.957,0c4.484,4.966,6.413,5.064,11.38.581-4.966,4.484-5.064,6.413-.581,11.38",
    transform: "translate(0.544)",
    fill: "#fc9819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9761",
    "data-name": "\\u30D1\\u30B9 9761",
    d: "M73.868,62.122C62.262,53.181,61.243,41.463,60.247,35.27a21.707,21.707,0,0,0,9.072-5.695,18.24,18.24,0,0,0,4.41-9.018l-15.355.052.011-.008A18.824,18.824,0,0,0,41.349,7.153c-9.693-.306-15.382,7.771-15.758,8.324A21.247,21.247,0,0,1,42.413,14.2a20.18,20.18,0,0,1,6.868,4.2c-2.749.047-5.977,1.912-7.832,4.036a10.942,10.942,0,0,0-2.489,5.487l9.415-.3a11.294,11.294,0,0,0,2.746,6.913c-21.385-.122-37.448,8.22-39.7,18.664C10.913,55.527,9.5,64.1,15.19,69.6a21.7,21.7,0,0,0,7.277,4.468l21.47-.007A20.135,20.135,0,0,1,38,72.207a17.651,17.651,0,0,1-2.3-1.5c-.044-.034-.254-.2-.483-.4-1.739-1.48-6.525-6.082-5.364-12.247,1.34-7.114,8.829-9.362,9.362-9.514a14.3,14.3,0,0,1,11.849,2.173,29.639,29.639,0,0,0,.682,3.721c2.474,9.894,9.525,16.3,14.032,19.628L90.6,70.19a50.576,50.576,0,0,1-16.731-8.068M57.083,24.452a1.784,1.784,0,1,1-1.78,1.784,1.783,1.783,0,0,1,1.78-1.784m5.055,34.893a29.133,29.133,0,0,1-5.589-23.122A37.288,37.288,0,0,0,64.1,58.847,41.881,41.881,0,0,0,76.5,69.7,33.573,33.573,0,0,1,62.137,59.344",
    transform: "translate(-10.889 1.499)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBexLogo);
export default __webpack_public_path__ + "static/media/ai-bex-logo.67b37d0511976d3c4f60339324289e0c.svg";
export { ForwardRef as ReactComponent };